import jQuery from "jquery";

const niceNumber = (function ($) {
  $.fn.niceNumber = function (options) {
    const defaults = {
      autoSize: true,
      autoSizeBuffer: 1,
      buttonDecrement: "-",
      buttonIncrement: "+",
      buttonPosition: "around",

      /**
        callbackFunction
        @param {$input} currentInput - the input running the callback
        @param {number} amount - the amount after increase/decrease
        @param {object} settings - the passed niceNumber settings
      * */
      onDecrement: false,
      onIncrement: false,
    };
    const settings = $.extend(defaults, options);

    return this.each(function () {
      const currentInput = this;
      const $currentInput = $(currentInput);
      const maxValue = $currentInput.attr("max");
      const minValue = $currentInput.attr("min");
      let attrMax = null;
      let attrMin = null;

      // Skip already initialized input
      if ($currentInput.attr("data-nice-number-initialized")) return;

      // Handle max and min values
      if (
        maxValue !== undefined
        && maxValue !== false
      ) {
        attrMax = parseFloat(maxValue);
      }

      if (
        minValue !== undefined
        && minValue !== false
      ) {
        attrMin = parseFloat(minValue);
      }

      // Fix issue with initial value being < min
      if (attrMin && !currentInput.value) {
        $currentInput.val(attrMin);
      }

      // Generate container
      const $inputContainer = $("<div/>", {
        class: "nice-number",
      }).insertAfter(currentInput);

      // Generate interval (object so it is passed by reference)
      const interval = {};

      // Generate buttons
      const $minusButton = $("<button/>")
        .attr("type", "button")
        .html(settings.buttonDecrement)
        .on("mousedown mouseup mouseleave", (event) => {
          changeInterval(event.type, interval, () => {
            const currentValue = parseFloat($currentInput.val() || 0);
            if (
              attrMin == null
              || attrMin < currentValue
            ) {
              const newValue = currentValue - 1;
              $currentInput.val(newValue);
              if (settings.onDecrement) {
                settings.onDecrement(
                  $currentInput,
                  newValue,
                  settings
                );
              }
            }
          });

          // Trigger the input event here to avoid event spam
          if (event.type == "mouseup" || event.type == "mouseleave") {
            $currentInput.trigger("input");
          }
        });

      const $plusButton = $("<button/>")
        .attr("type", "button")
        .html(settings.buttonIncrement)
        .on("mousedown mouseup mouseleave", (event) => {
          changeInterval(event.type, interval, () => {
            const currentValue = parseFloat($currentInput.val() || 0);
            if (
              attrMax == null
              || attrMax > currentValue
            ) {
              const newValue = currentValue + 1;
              $currentInput.val(newValue);
              if (settings.onIncrement) {
                settings.onIncrement(
                  $currentInput,
                  newValue,
                  settings
                );
              }
            }
          });

          // Trigger the input event here to avoid event spam
          if (event.type == "mouseup" || event.type == "mouseleave") {
            $currentInput.trigger("input");
          }
        });

      // Remember that we have initialized this input
      $currentInput.attr("data-nice-number-initialized", true);

      // Append elements
      switch (settings.buttonPosition) {
        case "left":
          $minusButton.appendTo($inputContainer);
          $plusButton.appendTo($inputContainer);
          $currentInput.appendTo($inputContainer);
          break;
        case "right":
          $currentInput.appendTo($inputContainer);
          $minusButton.appendTo($inputContainer);
          $plusButton.appendTo($inputContainer);
          break;
        case "around":
        default:
          $minusButton.appendTo($inputContainer);
          $currentInput.appendTo($inputContainer);
          $plusButton.appendTo($inputContainer);
          break;
      }

      // Nicely size input
      if (settings.autoSize) {
        $currentInput.width(
          `${$currentInput.val().length + settings.autoSizeBuffer}ch`
        );
        $currentInput.on("keyup input", () => {
          $currentInput.animate(
            {
              width:
                `${$currentInput.val().length
                + settings.autoSizeBuffer
                }ch`,
            },
            200
          );
        });
      }
    });
  };

  function changeInterval(eventType, interval, callback) {
    if (eventType == "mousedown") {
      interval.timeout = setTimeout(() => {
        interval.actualInterval = setInterval(() => {
          callback();
        }, 100);
      }, 200);
      callback();
    } else {
      if (interval.timeout) {
        clearTimeout(interval.timeout);
      }
      if (interval.actualInterval) {
        clearInterval(interval.actualInterval);
      }
    }
  }
}(jQuery));
